import { createFileRoute, Navigate } from '@tanstack/react-router'
import ForgotPasswordPage from 'pages/forgot-password/ForgotPasswordPage'
import { useIsLoggedIn } from 'hooks/useIsLoggedIn'

export const Route = createFileRoute('/forgot-password')({
  component: ForgotPasswordRoute,
})

function ForgotPasswordRoute() {
  const isLoggedIn = useIsLoggedIn()

  if (isLoggedIn) {
    return <Navigate to="/app" />
  }

  return <ForgotPasswordPage />
}
